<template>
  <div class="graduate-apply">
    <ul class="changestateul">
      <li v-for="(tab, index) in tabs" @click="toggle(index, tab.view)" :class="{ active: active == index }" :key="index">
        {{ tab.type }}
      </li>
    </ul>
    <div class="clearfix"></div>
    <!--:is实现多个组件实现同一个挂载点-->
    <component :is="currentView" :applyType="applyType"></component>
  </div>
</template>

<script>
import GraduateApplyForm from './graduateApplyTabs/apply.vue';
import GraduateApplyRecord from './graduateApplyTabs/record.vue';

export default {
  name: 'GraduateApply',
  components: {
    GraduateApplyForm,
    GraduateApplyRecord,
  },
  props: {
    applyType: {
      type: Number,
      default: 0,
    },
  },
  data: function() {
    // 根据 applyType 动态设置 Tab 名称
    let tabLabel = '毕业和学位申请';
    if (this.applyType === 1) {
      tabLabel = '毕业申请';
    } else if (this.applyType === 2) {
      tabLabel = '学位申请';
    }
    return {
      active: 0,
      currentView: 'GraduateApplyForm',
      tabs: [
        {
          type: tabLabel,
          view: 'GraduateApplyForm',
        },
        {
          type: '申请记录',
          view: 'GraduateApplyRecord',
        },
      ],
    };
  },
  methods: {
    toggle(i, v) {
      this.active = i;
      this.currentView = v;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.graduate-apply {
  background: $bgcontent;
  min-height: 500px;
  padding: 0 20px 20px;

  .changestateul {
    display: flex;
    margin: 0;
    padding: 20px 0 20px 12px;
    list-style: none;
  }

  .changestateul li {
    margin-right: 20px;
    padding: 0 24px;
    height: 36px;
    line-height: 36px;
    background: #ffffff;
    color: #999999;
    cursor: pointer;
    text-align: center;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &.active {
      background: $bgColor;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/GraduateApply.vue